import arabic from "../components/SelectLanguage/images/arabic.png"
import english from "../components/SelectLanguage/images/english.png"
export const LANGUAGES = [
  { label: "العربية", code: "ar", value: "ar", name: "arabic", directionality: "rtl", logo: arabic },
  { label: "English", code: "en", value: "en", name: "english", directionality: "ltr", logo: english },

];
